export default __webpack_public_path__ + "static/media/logo-light.3b1ba6c1.svg";